module.exports = __webpack_public_path__ + "img/tbbt.1153fa35.svg";